import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  EndPoints,
  OrderStatus,
  StaticBody,
} from '../../../common/enums/enums';
import { amplifyApi } from '../../../hooks/amplifyApi';
import { orderActionTypes } from '../../types';

export const openDeclineDialog = createAction(
  orderActionTypes.openDeclineDialog
);

export const closeDeclineDialog = createAction(
  orderActionTypes.closeDeclineDialog
);

export const clearDeclinedConfirmation = createAction(
  orderActionTypes.clearDeclinedConfirmation
);

export const closeApproveDialog = createAction(
  orderActionTypes.closeApproveDialog
);

export const getUnapprovedOrders = createAsyncThunk(
  orderActionTypes.getUnapprovedOrders,
  async ({ companyId, departments, pageNumber, searchQuery }) => {
    return await amplifyApi(
      {
        ...StaticBody.orders.unapproved,
        pageSize: StaticBody.orders.unapproved.pageSize,
        searchQuery,
        pageNumber,
        groupedFilters: {
          AND: [
            {
              AND: [
                {
                  column: 'companyId',
                  value: companyId,
                  operator: 'eq',
                },
                {
                  column: 'requiresApproval',
                  value: 'true',
                  operator: 'eq',
                },
              ],
            },
            {
              OR: departments.map(department => ({
                column: 'departmentId',
                value: department.departmentId,
                operator: 'eq',
              })),
            },
          ],
        },
      },
      EndPoints.ORDERS.UNAPPROVED.GET_ORDERS.ENDPOINT,
      EndPoints.ORDERS.UNAPPROVED.GET_ORDERS.METHOD
    );
  }
);

export const declineOrder = createAsyncThunk(
  orderActionTypes.declineOrder,
  async (
    { companyId, departments, searchQuery, order, observation },
    { dispatch }
  ) => {
    await amplifyApi(
      {
        status: OrderStatus.declined,
        observation,
      },
      `${EndPoints.ORDERS.UNAPPROVED.APPROVE_DECLINE_ORDER.ENDPOINT}${order.vendorOrderId}`,
      EndPoints.ORDERS.UNAPPROVED.APPROVE_DECLINE_ORDER.METHOD
    );

    dispatch(
      getUnapprovedOrders({
        companyId,
        departments,
        pageNumber: 1,
        searchQuery,
      })
    );

    return true;
  }
);

export const approveOrder = createAsyncThunk(
  orderActionTypes.approveOrder,
  async ({ companyId, departments, searchQuery, order }, { dispatch }) => {
    await amplifyApi(
      {
        status: OrderStatus.approved,
      },
      `${EndPoints.ORDERS.UNAPPROVED.APPROVE_DECLINE_ORDER.ENDPOINT}${order.vendorOrderId}`,
      EndPoints.ORDERS.UNAPPROVED.APPROVE_DECLINE_ORDER.METHOD
    );

    dispatch(
      getUnapprovedOrders({
        companyId,
        departments,
        pageNumber: 1,
        searchQuery,
      })
    );

    return true;
  }
);
